import React from "react";
import styled from "styled-components";
import headImg from "../../assets/images/sub-head-img2.jpg";
import mHeadImg from "../../assets/images/m-sub-head-img2.jpg";
import {useNavigate} from "react-router-dom";
import {device} from "../../assets/styles/media.js";

const HeadImg = styled.div`
    position: relative;
    z-index: 99;
    max-width: 100vw;
    width: 100%;
    height: 480px;
    background: url(${headImg});
    background-size: cover;
    margin-bottom: 70px;
    
    &::after {
        position: absolute;
        top:0;
        display: block;
        content: "";
        width: 100%;
        height: 480px;
        background-color: #000;
        opacity: 0.2;
    }

    ${device.tablet} {
        width: 100%;
        height: 450px;
        background: url(${mHeadImg});
        background-size: 100% auto;

        &::after {
            height: 450px;
        }

    }

    ${device.mobile} {
        width: 100%;
        height: 240px;
        margin-bottom: 20px;
        background: url(${mHeadImg});
        background-size: 100% auto;
        &::after {
            height: 240px;
        }
    }
`;
const StoryInfo = styled.a`
    box-sizing: border-box;
    position: absolute;
    top: 110px;
    display: inline-block;
    width: 100%;
    text-align: center;
    padding: 60px 30px;
    cursor: pointer;
    color: white;
    z-index: 1000;

    ${device.mobile} {
       top: 10px;
    }
`;
const StoryTitle = styled.strong`
    display: block;
    font-size: 45px;
    line-height: 42px;
    letter-spacing: 0.5px;
    margin-bottom: 28px;
    font-weight: 800;
  
    ${device.mobile} {
        font-size: 25px;
        line-height: 10px;
        font-weight: 800;
        letter-spacing: 0;
        margin-bottom: 18px;
    }

`;
const StoryTxt = styled.p`
    display: inline-block;
    font-size: 18px;
    padding: 5px 20px;
    border-radius: 20px;
    line-height: 28px;
    letter-spacing: -0.5px;
    margin-bottom: 40px;
    color: #4a4a4a;
    font-weight: 500;
    background-color: #fff;

    ${device.mobile} {
        font-size: 13px;
        padding: 3px 12px;
        margin-bottom: 20px;
        font-weight: 500;
    }
`;

const DetailBtn = styled.span`
    padding-bottom: 2px;
    position: relative;
    display: block;
    &::before {
        content: "";
        position: absolute;
        bottom: 0;
        display: inline-block;
        width: 64px;
        height: 2px;
        border-bottom: 1px solid #fff;
    }

    ${device.tablet} {
        margin-top: 20px;
        font-size: 18px;
        &::before {
            width: 85px;
        }
    }
    ${device.mobile} {
        font-size: 12px;
        &::before {
            width: 55px;
        }
    }
`;

const DStoryHead = () => {
    const navigate = useNavigate();
    return (
        <HeadImg>
            <StoryInfo>
                <StoryTitle>자연을 담은 강아지숲 이야기</StoryTitle>
                <StoryTxt>자연과의 공존을 이야기하는 강아지숲 탄생 스토리</StoryTxt>
                <DetailBtn onClick={()=>navigate("/notice/dstory")}>자세히보기</DetailBtn>
            </StoryInfo>
        </HeadImg>
    );
};

export default DStoryHead;
